<script setup lang="ts">
import { SwitchButton } from '@element-plus/icons-vue';

const visible = defineModel<boolean>('visible', { required: true });

const emit = defineEmits<{
  confirm: [];
  cancel: [];
}>();

function handleConfirm() {
  visible.value = false;
  emit('confirm');
}

function handleCancel() {
  visible.value = false;
  emit('cancel');
}
</script>

<template>
  <ElDialog
    v-model="visible"
    width="360px"
    align-center
    aria-label="确认退出"
    class="logout-confirm-dialog"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <div class="flex flex-col items-center pt-4 text-center">
      <!-- 退出图标：警示色圆底 + 柔和光晕 -->
      <div class="logout-icon">
        <ElIcon :size="26"><SwitchButton /></ElIcon>
      </div>

      <h3 class="mt-4 text-lg font-semibold tracking-tight text-[var(--color-title)]">
        确认退出
      </h3>
      <p class="mt-2 max-w-[250px] text-sm leading-relaxed text-[var(--color-caption)]">
        确定要退出当前账号吗？退出后需要重新登录。
      </p>
    </div>

    <template #footer>
      <div class="flex gap-3">
        <ElButton class="logout-btn flex-1" size="large" @click="handleCancel">
          取消
        </ElButton>
        <ElButton class="logout-btn flex-1" size="large" type="primary" @click="handleConfirm">
          确认退出
        </ElButton>
      </div>
    </template>
  </ElDialog>
</template>

<style scoped>
/* ElDialog Teleport 到 body，覆盖 style.css 全局对话框样式需用 :global */
:global(.logout-confirm-dialog) {
  box-shadow: var(--shadow-level-4);
}

/* 隐藏默认标题栏，改用居中的图标 + 标题布局 */
:global(.logout-confirm-dialog .el-dialog__header) {
  display: none;
}

:global(.logout-confirm-dialog .el-dialog__body) {
  padding: 28px 28px 0 !important;
}

:global(.logout-confirm-dialog .el-dialog__footer) {
  border-top: none;
  padding: 20px 28px 28px !important;
}

/* 图标底座：警示色柔和圆底，带一圈低透明度光晕 */
.logout-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 9999px;
  color: var(--color-warning);
  background: var(--color-warning-light);
  box-shadow: 0 0 0 10px color-mix(in srgb, var(--color-warning) 8%, transparent);
  animation: scaleIn 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) 0.05s both;
}

/* 按钮统一大圆角，与整体卡片风格一致 */
.logout-btn {
  border-radius: var(--radius-md);
}
</style>
